import { default as QuantityButton } from 'checkout/containers/ProductQuantity'

import { ChangeItemTypeButton } from 'newCheckout/pages/Cart/components/ChangeItemTypeButton'

import { ServiceQuantity } from '../StandaloneService/Quantity'
import PriceInfo from './PriceInfo'
import * as S from './styled'

const PriceWrapperMobile = ({
  discountByPaymentMethod,
  packaging,
  packagingCount,
  translatedUnit,
  quantity,
  price,
  brand,
  name,
  categoryTree,
  id,
  productId,
  regionId,
  shippingType,
  shopName,
  skuId,
  storeId,
  updateProduct,
  onSuccess,
  onError,
  isHybridEnabled,
  changeItemTypeCallback,
  cartId,
  itemAvailableStores,
  dataLayerInfo,
  installments,
  isStandaloneService,
  fetchPriceShipping,
  zipCode
}) => {
  return (
    <S.PriceWrapper isMobile={true}>
      <PriceInfo
        packaging={packaging}
        packagingCount={packagingCount}
        translatedUnit={translatedUnit}
        quantity={quantity}
        price={price}
        isMobile={true}
        discountByPaymentMethod={discountByPaymentMethod}
        installments={installments}
      />
      {isStandaloneService ? (
        <ServiceQuantity id={id} regionId={regionId} quantity={quantity} callback={fetchPriceShipping} />
      ) : (
        <QuantityButton
          pageType="cart"
          brand={brand}
          name={name}
          categoryTree={categoryTree}
          id={id}
          productId={productId}
          regionId={regionId}
          type={shippingType}
          shopName={shopName}
          quantity={quantity}
          packaging={packaging}
          packagingCount={packagingCount}
          skuId={skuId}
          storeId={storeId}
          price={price}
          discountByPaymentMethod={discountByPaymentMethod}
          updateProduct={updateProduct}
          onSuccess={onSuccess}
          onError={onError}
          fromCart
          zipCode={zipCode}
        />
      )}
      {isHybridEnabled && (
        <S.ChangeItemTypeMobileWrapper>
          <ChangeItemTypeButton
            type={shippingType}
            callback={changeItemTypeCallback}
            cartId={cartId}
            itemId={id}
            itemAvailableStores={itemAvailableStores}
            dataLayerInfo={dataLayerInfo}
          />
        </S.ChangeItemTypeMobileWrapper>
      )}
    </S.PriceWrapper>
  )
}

export default PriceWrapperMobile
